import { TDoor } from 'shared/types/doors';
import { DoorContent } from '../DoorContent';

export const EighthDoorContent: React.FC<TDoor> = props => {
  return (
    <DoorContent btnText="Открыть поздравление" {...props}>
      <div>
        Вот и подошел к финалу наш адвент — время подвести итоги и подготовиться к новым свершениям. Желаем, чтобы 2026
        год принёс вам много благодарных гостей, выгодных бронирований и уютных отзывов.
      </div>
      <div>
        <div>
          <b>🎁 В этом окошке — особенный подарок</b>
        </div>
        <div>
          <b>Поздравление от Екатерины Десятовой,</b> руководителя Циан Посуточно. А ещё —{' '}
          <b>набор праздничных аватарок для хостов.</b> Поделитесь своим настроением и статусом с гостями и коллегами!
        </div>
      </div>
      <div>Желаем вам вдохновения, уюта и успешного года! 💙</div>
      <div>
        Смотрите видео-поздравление в сообществе хостов в Telegram, получайте подарок и вдохновляйтесь на покорение
        новых вершин в следующем году 💙
      </div>
      <div>С наступающим 2026 годом!</div>
    </DoorContent>
  );
};
